import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClaudeOutlineAiIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m12.1 15.3.5.4.8 1.8 1.2 2.8 2 3.7.6 1.2.3 1v.3h.3v-.1l.1-2.2.3-2.6.3-3.4.1-1 .5-1 .9-.7.8.4.6.8-.1.6-.4 2.3-.7 3.6-.5 2.5h.3l.3-.4 1.2-1.6 2-2.6 1-1 1-1.1.8-.6h1.2l1 1.4-.4 1.5-1.4 1.7-1 1.4-1.7 2.1-1 1.7.2.2h.2l3.6-.8 1.9-.3 2.3-.4 1 .4.1.5-.4 1-2.4.6-3 .6-4.2 1v.2l2 .1.7.1h2l3.9.3 1 .6.5.8v.6l-1.6.8-2-.5-4.8-1-1.7-.4h-.2v.1l1.4 1.3 2.5 2.3 3.2 3 .1.6-.4.6h-.4l-2.8-2.1-1-1-2.4-2H22v.2l.5.8 3 4.5.1 1.3-.2.4-.8.3-.8-.2-1.7-2.4-1.8-2.7-1.4-2.4-.2.1-.8 9-.4.5-1 .4-.7-.6-.4-1 .4-1.8.5-2.4.4-1.9.4-2.4.2-.8h-.2l-1.8 2.5-2.7 3.7-2.2 2.2-.5.3-1-.5.2-.8.5-.7 3-3.9 1.8-2.3 1.2-1.4V33h-.2l-7.9 5.2-1.4.2-.6-.6v-1l.4-.2L8.4 35l5.8-3.3.1-.3v-.1h-1.4L9.7 31l-3-.1-2.8-.2-.7-.1-.6-1v-.4l.6-.4.9.1L6 29l2.8.2 2.1.1 3 .4h.5l.1-.2-.2-.1v-.1l-3-2-3.3-2L6.3 24l-.9-.6-.5-.6-.1-1.2.8-1 1 .2H7l1 1 2.5 1.7 3 2.4.5.3h.2V26l-.2-.3-1.6-3.1-1.8-3.1-.9-1.3-.2-.8v-1l.8-1.2.6-.1zM37.4 3q.8 0 1 .8V4l.4 2q.6 2.1 1.6 3.2 1.2 1.1 3.2 1.6l2 .4h.2a1 1 0 0 1 0 1.9h-.2l-2 .5q-2 .4-3.2 1.5c-1.2 1.1-1.2 2-1.6 3.3l-.4 2v.1a1 1 0 0 1-1.9 0l-.5-2.1q-.4-2.1-1.5-3.3c-1.1-1.2-2-1.2-3.3-1.5l-2-.5h-.1a1 1 0 0 1 0-1.8h.1l2-.5q2.1-.5 3.3-1.6c.7-.6 1.2-2 1.5-3.2l.5-2v-.2a1 1 0 0 1 1-.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#claudeOutlineAiGradient)",
			d: "m12.1 15.3.5.4.8 1.8 1.2 2.8 2 3.7.6 1.2.3 1v.3h.3v-.1l.1-2.2.3-2.6.3-3.4.1-1 .5-1 .9-.7.8.4.6.8-.1.6-.4 2.3-.7 3.6-.5 2.5h.3l.3-.4 1.2-1.6 2-2.6 1-1 1-1.1.8-.6h1.2l1 1.4-.4 1.5-1.4 1.7-1 1.4-1.7 2.1-1 1.7.2.2h.2l3.6-.8 1.9-.3 2.3-.4 1 .4.1.5-.4 1-2.4.6-3 .6-4.2 1v.2l2 .1.7.1h2l3.9.3 1 .6.5.8v.6l-1.6.8-2-.5-4.8-1-1.7-.4h-.2v.1l1.4 1.3 2.5 2.3 3.2 3 .1.6-.4.6h-.4l-2.8-2.1-1-1-2.4-2H22v.2l.5.8 3 4.5.1 1.3-.2.4-.8.3-.8-.2-1.7-2.4-1.8-2.7-1.4-2.4-.2.1-.8 9-.4.5-1 .4-.7-.6-.4-1 .4-1.8.5-2.4.4-1.9.4-2.4.2-.8h-.2l-1.8 2.5-2.7 3.7-2.2 2.2-.5.3-1-.5.2-.8.5-.7 3-3.9 1.8-2.3 1.2-1.4V33h-.2l-7.9 5.2-1.4.2-.6-.6v-1l.4-.2L8.4 35l5.8-3.3.1-.3v-.1h-1.4L9.7 31l-3-.1-2.8-.2-.7-.1-.6-1v-.4l.6-.4.9.1L6 29l2.8.2 2.1.1 3 .4h.5l.1-.2-.2-.1v-.1l-3-2-3.3-2L6.3 24l-.9-.6-.5-.6-.1-1.2.8-1 1 .2H7l1 1 2.5 1.7 3 2.4.5.3h.2V26l-.2-.3-1.6-3.1-1.8-3.1-.9-1.3-.2-.8v-1l.8-1.2.6-.1zM37.4 3q.8 0 1 .8V4l.4 2q.6 2.1 1.6 3.2 1.2 1.1 3.2 1.6l2 .4h.2a1 1 0 0 1 0 1.9h-.2l-2 .5q-2 .4-3.2 1.5c-1.2 1.1-1.2 2-1.6 3.3l-.4 2v.1a1 1 0 0 1-1.9 0l-.5-2.1q-.4-2.1-1.5-3.3c-1.1-1.2-2-1.2-3.3-1.5l-2-.5h-.1a1 1 0 0 1 0-1.8h.1l2-.5q2.1-.5 3.3-1.6c.7-.6 1.2-2 1.5-3.2l.5-2v-.2a1 1 0 0 1 1-.8"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "claudeOutlineAiGradient",
			x1: 47.11,
			x2: -2.46,
			y1: 3,
			y2: 56.67,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#e2a9ff" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .34,
					stopColor: "#bb97f6"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .65,
					stopColor: "#8b5cf6"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#602bcc"
				})
			]
		}) })
	]
});
export default SvgClaudeOutlineAiIcon;
